// extracted by mini-css-extract-plugin
export default {"italic":"lbsVUH3bb2lersgQgTEr","link":"gOXLg1Fy8Won0rGY7_3m"};